<template>
  <div>
    <el-button @click="addProject">添加运维项目</el-button>
    <!-- <div is="view-container" id="baidu" style="height:100px;width:100px;background:#000;" v-pre></div> -->

    <div class="list">
      <div class="video-item-config" v-for="item in list" :key="item.id">
        <div>{{ item.name }}</div>
        <div class="edit-content">
          <el-button
            type="primary"
            icon="el-icon-edit"
            circle
            @click="update(item)"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            @click="remove(item)"
          ></el-button>
        </div>
      </div>
    </div>

    <el-dialog
      title="添加运维项目"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="30%"
    >
      <el-form :model="form">
        <!-- <el-form-item label="摄像头类型" :label-width="formLabelWidth">
          <el-select v-model="form.type" placeholder="选择摄像头类型">
            <el-option label="萤石" value="shanghai"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="Key" :label-width="formLabelWidth">
          <el-input v-model="form.Key" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="巡检项目名称" :label-width="formLabelWidth">
          <el-input v-model="form.Name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="巡检项目数据类型" :label-width="formLabelWidth">
          <!-- <el-input v-model="form.DataType" autocomplete="off"></el-input> -->
          <el-select v-model="form.DataType" placeholder="请选择">
            <el-option
              v-for="item in DataType"
              :key="item.type"
              :label="item.label"
              :value="item.type"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡检模块标识" :label-width="formLabelWidth">
          <!-- <el-input v-model="form.OpsType" autocomplete="off"></el-input> -->
          <el-radio v-model="form.OpsType" :label="0">生产数据</el-radio>
          <el-radio v-model="form.OpsType" :label="1">水质检测</el-radio>
          <el-radio v-model="form.OpsType" :label="2">设备巡检</el-radio>
          <el-radio v-model="form.OpsType" :label="3">工艺巡检</el-radio>
        </el-form-item>
        <el-form-item label="单位" :label-width="formLabelWidth">
          <el-input v-model="form.Unit" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="最大值" :label-width="formLabelWidth">
          <el-input
            type="number"
            v-model="form.Max"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="最小值" :label-width="formLabelWidth">
          <el-input
            type="number"
            v-model="form.Min"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitConfig">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { uuid,rid } from "@/libs/src/utils/tools.js";
import Core from "@/libs/src/core.js";
import { DATA_TYPE } from "./type/types";
const formData = {
  Key: "",
  Name: "",
  DataType: "",
  OpsType: "0",
  Unit: "",
  Max: 0.0,
  Min: 0.0,
};
/**
 * @readonly
 * @enum
 */
const dialogType = {
  edit: 'update',
  add: 'add',
};
export default {
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: "150px",
      list: [],
      // radio：'0',
      dialogType: dialogType.add,
      DataType: [
        {
          label: "数值",
          type: DATA_TYPE.Number,
        },
        {
          label: "字符串",
          type: DATA_TYPE.String,
        },
        {
          label: "布尔",
          type: DATA_TYPE.Boolean,
        },
        {
          label: "枚举",
          type: DATA_TYPE.Enum,
        },
      ],
      form: {
        Key: "",
        Name: "",
        DataType: "",
        OpsType: "0",
        Unit: "",
        Max: 0.0,
        Min: 0.0,
      },
    };
  },
  created() {
    this.Operation = Core.getProvider("DPC").operation;
    this.init();
  },
  methods: {
    async init() {
      let res = await this.Operation.searchProject("");
      this.list = res.data;
    },
    addProject() {
      this.dialogType = dialogType.add;
      this.dialogVisible = true;
      this.form = JSON.parse(JSON.stringify(formData));
      this.form.Key = rid();
    },
    async submitConfig() {
     
      await this.Operation.addProject(this.form, this.dialogType);
      this.dialogVisible = false;
      this.init();
    },
    remove(item) {
      if (!confirm("确认删除？")) return;
      this.Operation.removeOpsProject(item.id).then((res) => {
        if (res.success) {
          this.init();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    update(item) {
      console.log(item);
      this.form.id = item.id
      this.form.Name = item.name
      this.form.Key = item.key
      this.form.DataType = item.dataType
      this.form.OpsType = item.opsType
      this.form.Unit = item.unit
      this.form.Max = item.max
      this.form.Min = item.min
      this.dialogType = dialogType.edit;
      this.dialogVisible = true;
      // this.Operation.updateOpsProject(this.formData)
      // this.Operation.addProject()

    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  height: 95vh;
  overflow-y: auto;
}
.video-config-conatiner {
  padding: 30px;
}
.video-item-config {
  padding: 10px 15px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #515151;
  &:hover {
    background: rgba($color: #ccc, $alpha: 0.2);
  }
}
</style>